module.exports = __webpack_public_path__ + "img/page_5_1.aec70d6b.png";